import React from 'react';
import { Entity } from '../../types/index';
import { CustomSider } from '../../components/layout/CustomSider';
import { Icon } from '@ant-design/compatible';
import { Document, Page } from 'react-pdf';
import { Button, Spin } from 'antd';
import { AsideSectionMask, BundledPages, FailedToLoadPage } from './components';

const WIDTH = 100;
const HEIGHT = 140;

type Props = {
  file: any;
  mainDocumentWrapper: React.RefObject<HTMLDivElement>;
  asideDocumentWrapper: React.RefObject<HTMLDivElement>;
  asideSectionMask: React.RefObject<HTMLDivElement>;
  entities: Entity[];
  handleClick: (id: string) => any;
  documentScrollHeight: { start: number; end: number };
  setDocumentScrollHeight: (any: any) => any;
  filterItemsCount: number;
  setFilterItemsCount: (number: any) => any;
  onDocumentLoadSuccess: any;
  numPages: number;
};

export const MiniSidebar = ({
  file,
  mainDocumentWrapper,
  asideDocumentWrapper,
  asideSectionMask,
  entities,
  handleClick,
  documentScrollHeight,
  setDocumentScrollHeight,
  filterItemsCount,
  setFilterItemsCount,
  onDocumentLoadSuccess,
  numPages,
}: Props) => {
  return (
    <CustomSider width="160px" style={{ background: '#efefef', borderRight: '1px solid #c2c2c2' }}>
      <div ref={asideDocumentWrapper} className="relative">
        {entities
          .filter((_, i) => i < filterItemsCount)
          .map(entity => {
            return (
              <div key={entity.id} className="relative mx-auto my-0 py-1.5" style={{ width: WIDTH }}>
                <div
                  onClick={() => {
                    if (entities.length) handleClick(entity.id);
                  }}
                  className="flex justify-center items-center cursor-pointer"
                  style={{
                    width: WIDTH,
                    height: HEIGHT,
                    border: '1px solid #aaa',
                    background: '#f0f0f0',
                  }}>
                  <Document
                    file={file}
                    loading={<Spin />}
                    className="pointer-events-none"
                    onLoadSuccess={onDocumentLoadSuccess}>
                    {numPages > 0 ? (
                      <Page
                        className="border border-solid border-gray-400"
                        height={HEIGHT}
                        width={WIDTH}
                        pageNumber={entity.start_page}
                        error={<FailedToLoadPage width={WIDTH} height={HEIGHT} />}
                      />
                    ) : null}
                  </Document>
                </div>
                {numPages > 0 ? (
                  <BundledPages width={4} docWidth={WIDTH} docHeight={HEIGHT} entity={entity} origin="nav" />
                ) : null}
              </div>
            );
          })}
        <AsideSectionMask asideSectionMask={asideSectionMask} documentScrollHeight={documentScrollHeight} />
      </div>
      {filterItemsCount < entities.length ? (
        <div className="flex justify-center items-center p-4">
          <Button
            type="text"
            onClick={() => {
              setFilterItemsCount((prev: any) => prev + 20);
              mainDocumentWrapper.current?.scrollBy(0, 1);
            }}>
            <Icon type="double-right" style={{ transform: 'rotate(90deg)', fontSize: '20px', color: '#222' }} />
          </Button>
        </div>
      ) : null}
    </CustomSider>
  );
};
